module.exports = __webpack_public_path__ + "static/media/man-2.333fa0cb.svg";